var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandmarkicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.379,
    height: 15.86,
    viewBox: "0 0 13.379 15.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin_1_",
    "data-name": "pin (1)",
    transform: "translate(-2.95 -1.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33868",
    "data-name": "Path 33868",
    d: "M9.64,17.1a.544.544,0,0,1-.389-.162L5.018,12.71a6.54,6.54,0,1,1,9.244,0l-4.232,4.232A.544.544,0,0,1,9.64,17.1Zm0-14.453A5.437,5.437,0,0,0,5.8,11.931L9.64,15.774l3.843-3.843A5.437,5.437,0,0,0,9.64,2.65Z",
    transform: "translate(0)",
    fill: "#ff5e15",
    stroke: "#ff5e15",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33869",
    "data-name": "Path 33869",
    d: "M11.005,11.761a2.755,2.755,0,1,1,2.755-2.755A2.755,2.755,0,0,1,11.005,11.761Zm0-4.409a1.653,1.653,0,1,0,1.653,1.653A1.653,1.653,0,0,0,11.005,7.352Z",
    transform: "translate(-1.366 -1.248)",
    fill: "#ff5e15",
    stroke: "#ff5e15",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmarkicon);
export default __webpack_public_path__ + "static/media/landmarkicon.ee74bfc4e8c5c2bab76e5927a1ee4405.svg";
export { ForwardRef as ReactComponent };